import { TopBar } from './components/TopBar';
import { HEIGHT as GLOBAL_NAVIGATION_HEIGHT, Left, Right } from './styled';
// eslint-disable-next-line import/prefer-default-export
export const GlobalNavigation = {
    TopBar,
    GLOBAL_NAVIGATION_HEIGHT,
    Left,
    Right,
};
